import { Resource } from "react-admin";
import CustomerIcon from "@material-ui/icons/Mood";
import React from "react";

import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import Show from "./Show";
import { POLICY_CUSTOMERS } from "../../common/rolesManagement";
import PermissionDenied from "../../components/PermissionDenied";

export default permissions => (
    <Resource
        name="customers"
        icon={CustomerIcon}
        list={
            permissions && permissions.includes(POLICY_CUSTOMERS.READ)
                ? List
                : PermissionDenied
        }
        show={
            permissions && permissions.includes(POLICY_CUSTOMERS.READ)
                ? Show
                : PermissionDenied
        }
        edit={
            permissions && permissions.includes(POLICY_CUSTOMERS.UPDATE)
                ? Edit
                : PermissionDenied
        }
        create={
            permissions && permissions.includes(POLICY_CUSTOMERS.CREATE)
                ? Create
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Customers/index.js